import { render, staticRenderFns } from "./ExamCorrection.vue?vue&type=template&id=0a55d508&"
import script from "./ExamCorrection.vue?vue&type=script&lang=js&"
export * from "./ExamCorrection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports